// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import store from './store';
import App from './App'
import router from './router'
import {appRouter} from './router/router';
import iView from 'iview';
import 'iview/dist/styles/iview.css';
import * as Cache from './cache/Cache';
import Util from './libs/util';

Vue.use(iView);
Vue.config.productionTip = false
//设置全局router 可以直接使用this.router.push()跳转
Vue.prototype.router = router
//EventBus事件总线
Vue.prototype.eventBus = new Vue();
//打印
import Print from 'vue-print-nb'
Vue.use(Print); //注册


new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
  mounted () {
  },
  created () {
    global.vm = this;
  },

})

/**全局自定义指令*/

//按钮权限的指令
Vue.directive('permission',{
  inserted: function (el, binding) {
    let permissionInfo = Cache.getPermissions();
    let permissions = permissionInfo ? permissionInfo : [];
    let permissionId = binding.value;
    if(!Util.isHavePermission(permissionId, permissions)) {
      el.parentNode.removeChild(el);
    }
  }
})



// WEBPACK FOOTER //
// ./src/main.js